import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import PressLogoTile from './press-logo-tile';

const PressLogoSalad = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, nav) => (
    <PressLogoTile {...tile} key={`item-${nav}`} />
  ));

  const PressLogoContainer = (
    <div
      className={classNames([
        'logo-tile__container',
        classes('margin-horizontal-auto'),
        classes('display-flex'),
        classes('justify-content-center'),
        classes('flex-direction-row'),
        classes('flex-wrap'),
        classes('align-items-center'),
        classes('padding-vertical-4'),
      ])}
    >
      {renderedTiles}
    </div>
  );

  return (
    <div
      className={classNames([
        'logo__container',
        classes('margin-vertical-4'),
        classes('background-neutral-lightest'),
        classes('width-100'),
      ])}
    >
      {PressLogoContainer}
    </div>
  );
};

PressLogoSalad.displayName = 'PressLogoSalad';

PressLogoSalad.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(PressLogoSalad.propTypes)),
  nav: PropTypes.string,
};

export default PressLogoSalad;
